package pt.at.oss.kotlin.manual.storage.common.contactname.titles

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * TitlesEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class TitlesEntry(
    var name: String = ""
) : BaseRecord()
